import React from "react";

type OrderStatusNumber = 0 | 1 | 2;
type OrderStatusString = "Pendente" | "Sincronizado" | "Cancelado";

const StatusMap: Record<OrderStatusNumber, OrderStatusString> = {
  0: "Cancelado",
  1: "Pendente",
  2: "Sincronizado",
};

interface StatusBadgeProps {
  status: OrderStatusNumber | OrderStatusString;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => {
  const statusString: OrderStatusString =
    typeof status === "number" ? StatusMap[status] || "Cancelado" : status;

  const getStatusStyles = (status: OrderStatusString) => {
    switch (status) {
      case "Sincronizado":
        return "px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-green-100 border-green-200 text-green-500 dark:bg-green-500/20 dark:border-green-500/20";
      case "Pendente":
        return "px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-yellow-100 border-yellow-200 text-yellow-500 dark:bg-yellow-500/20 dark:border-yellow-500/20";
      case "Cancelado":
        return "px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-red-100 border-red-200 text-red-500 dark:bg-red-500/20 dark:border-red-500/20";
      default:
        return "px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-gray-100 border-gray-200 text-gray-500 dark:bg-gray-500/20 dark:border-gray-500/20";
    }
  };

  return (
    <div className="text-center">
      <span className={`delivery_status ${getStatusStyles(statusString)}`}>{statusString}</span>
    </div>
  );
};

export default StatusBadge;
